import React, { useEffect, useRef, useState } from "react";
import { useGlobalState } from "./GlobalStateProvider";
import { playSE } from "./SoundEffect";
import "./Nazo.css";
import { PostAchievement } from "./ModuleLinkFirebase";

export const PASS = "https://bad-assort.com/play/gothic-neue/pass.php";

export type JudgeRes = {
  "q"?: string,
  "judge": "ok" | "ng",
  "exemplar"?: string,
}

const NazoEx: React.FC = () => {
  const { isBusy, setBusy, currentStep, setCurrentStep } = useGlobalState();
  const [visiblePageIndex, setVisiblePageIndex] = useState<number>(0);
  const [yourAnsEffect, setYourAnsEffect] = useState<string>("");
  const [openLog, setOpenLog] = useState<boolean>(false);
  const yourAnsInputRef = useRef<HTMLInputElement | null>(null);

  const pageArray = [
    ["Phase 1", "Phase 1", "Phase 1", "Phase 1", "Phase 2", "Phase 2", "Phase 2", "Phase 3", "Phase 3", "Phase 3", "Phase 4", "Phase 5", "Phase 5"],
    [11, 13, 15, 17, 21, 23, 25, 31, 33, 35, 40, 51, 53],
    [12, 19, 16, 18, 22, 24, 0, 32, 34, 36, 41, 52, 0]
  ];

  const sendAns = async () => {
    if (!yourAnsInputRef.current || !yourAnsInputRef.current.value) return;
    setBusy(true);
    if (openLog) {
      const res: JudgeRes = await judgeEx();
      if (res.judge === "ok") {
        setYourAnsEffect("flash");
        playSE("se1")
        setTimeout(() => {
          setYourAnsEffect("");
          setCurrentStep(102);
          setBusy(false);
          PostAchievement(res.exemplar ?? "");
        }, 2000);
      } else {
        setYourAnsEffect("shake");
        playSE("se2");
        setTimeout(() => {
          setYourAnsEffect("");
          setBusy(false);
        }, 1000);
      }
    } else {
      const res: JudgeRes = await judge();
      if (res.judge === "ok") {
        setYourAnsEffect("flash");
        playSE("se1")
        setTimeout(() => {
          setYourAnsEffect("");
          setOpenLog(true);
          setBusy(false);
        }, 2000);
      } else {
        setYourAnsEffect("shake");
        playSE("se2");
        setTimeout(() => {
          setYourAnsEffect("");
          setBusy(false);
        }, 1000);
      }
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      sendAns();
    }
  };

  const judge: () => Promise<JudgeRes> = async () => {
    const ur_ans = yourAnsInputRef.current?.value;
    if (ur_ans) {
      let dat = { "q": `ques101`, "a": ur_ans };
      let response = await fetch(PASS, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(dat)
      });
      let res = await response.json();
      return res;
    }
    return { "judge": "ng" };
  };

  const judgeEx: () => Promise<JudgeRes> = async () => {
    let ur_ans = yourAnsInputRef.current?.value;
    if (ur_ans) {
      ur_ans = ur_ans.replace(/^(この本は、|この本は)/, "");
      ur_ans = ur_ans.replace(/(本。|本)$/, "");
      const ansArr = ur_ans.split(/(の|を|に|が|で)/, 5);
      let dat = { "q": `ques111`, "a1": ansArr[0], "a2": ansArr[2], "a3": ansArr[4] };
      let response = await fetch(PASS, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(dat)
      });
      let res = await response.json();
      return res;
    }
    return { "judge": "ng" };
  };

  function movePage(moveForward: boolean) {
    setVisiblePageIndex(prev => {
      if (moveForward) return Math.min(prev + 1, pageArray[0].length - 1);
      else return Math.max(prev - 1, 0);
    });
  }

  useEffect(() => {
    setBusy(false);
    setVisiblePageIndex(0);
  }, []);


  return <>
    <section id="nz-ex" className="nazo-section">
      {openLog ?
        <div id="nz-ex-modal" className="nz-modal">
          <p id="nz-ex-index">{pageArray[0][visiblePageIndex]}</p>
          <div style={{ display: "flex", flexDirection: "row" }}>
            <img id="nz-ex-img" src={`${process.env.PUBLIC_URL}/img/nazo${pageArray[1][visiblePageIndex]}.webp`} style={{ height: "min(48vw, 60vh)", opacity: "0.8" }}></img>
            <img id="nz-ex-img" src={`${process.env.PUBLIC_URL}/img/nazo${pageArray[2][visiblePageIndex]}.webp`} style={{ height: "min(48vw, 60vh)", opacity: "0.8" }}></img>
          </div>
          <div>
            <div id="prev-button" className="div-button" onClick={() => { movePage(false) }} style={{ visibility: `${visiblePageIndex == 0 ? "hidden" : "visible"}` }}>前ページ</div>
            <div id="fwrd-button" className="div-button" onClick={() => { movePage(true) }} style={{ visibility: `${visiblePageIndex == pageArray[0].length - 1 ? "hidden" : "visible"}` }}>次ページ</div>
          </div>
          <input type="text" id="your-ans" className={yourAnsEffect} ref={yourAnsInputRef} onKeyDown={handleKeyDown} disabled={isBusy ? true : false} autoComplete="off"></input>
          <div>
            <div id="judge-button" className="div-button" onClick={sendAns}>決定</div>
          </div>
        </div>
        :
        <div id="nz-ex-modal" className="nz-modal">
          <img id="nz-ex-img" src={`${process.env.PUBLIC_URL}/img/nazo99.webp`}></img>
          <input type="text" id="your-ans" className={yourAnsEffect} ref={yourAnsInputRef} onKeyDown={handleKeyDown} disabled={isBusy ? true : false} autoComplete="off"></input>
          <div>
            <div id="judge-button" className="div-button" onClick={sendAns}>決定</div>
          </div>
        </div>
      }
    </section>
  </>;

}

export default NazoEx;
